import { atom, computed } from 'nanostores'

import type { CMSLoggedInSettings } from '@/types/sanity'

export const $loggedInSettings = atom<CMSLoggedInSettings | null>(null)
export const $supplementsSettings = computed(
  $loggedInSettings,
  (loggedInSettings) => {
    return loggedInSettings?.supplements
  },
)
